export default __webpack_public_path__ + "images/6409ff22891ae4d064d7fe39c8db3b59.webp";